module.exports = __webpack_public_path__ + "static/full-1ee98076aae24880cbab1604f2aae88f.webm";